import React from "react";
import { Card, CardContent } from "@mui/material";
import { useTheme } from "@mui/material/styles";

interface ChartCardWrapperProps {
  renderCard: boolean;
  isModal?: boolean;
  children: React.ReactNode;
}

const ChartCardWrapper: React.FC<ChartCardWrapperProps> = ({
  renderCard,
  isModal = false,
  children,
}) => {
  const theme = useTheme();

  if (!renderCard) {
    return <>{children}</>;
  }

  return (
    <Card
      elevation={0}
      sx={{
        backgroundColor: theme.palette.mode === "dark" ? "#212121" : "#f5f5f5",
        ...(isModal && {
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }),
      }}
    >
      <CardContent
        sx={{
          ...(isModal && {
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }),
        }}
      >
        {children}
      </CardContent>
    </Card>
  );
};

export default ChartCardWrapper;
